export default {"src":"/_next/static/media/the-telegraph.bd8de396.svg","height":18,"width":108,"blurWidth":0,"blurHeight":0};